import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { DevolucoesOrcamento } from "./DevolucoesOrcamento";
import { useMenuSubConsultasDevolucoes } from "../menu-sub-consultas-devolucoes/useMenuSubConsultasDevolucoes";
import { useMenuConsultasPesquisaOrcamento } from "../menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";

export type DevolucoesOrcamentoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void,
    onRemover?: () => boolean
    passos: Dict<string, () => void>,
};

export const DevolucoesOrcamentoContainer = (props: DevolucoesOrcamentoContainerProps) => {
    const [dados, setDados] = useState<NotaFiscalDevolucao[]>([]);
    const [mostrarDetalhesDevolucoes, setMostrarDetalhesDevolucoes] = useState(false);
    const [devolucaoSelecionada, setDevolucaoSelecionada] = useState<Partial<NotaFiscalDevolucao>>(null)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosDevolucoes = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalEntrada.ListarDevolucoes(
                props.orcamentoSelecionado.NumeroPedido
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onSelecionarMostrarDevolucao = (mostrar: boolean, notaFiscal: NotaFiscalDevolucao) => {
        setMostrarDetalhesDevolucoes(mostrar)
        setDevolucaoSelecionada(notaFiscal)
    }

    const onRenderizarDevolucoes = () => renderizarComponentReact(
        <DevolucoesOrcamentoContainer {...props} />, "pesquisar-pedidos-region", true
    )

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }
 
    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuSubConsultasDevolucoes({
        devolucaoSelecionada: devolucaoSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => onRenderizarDevolucoes(),
        passos: passosInterno.current
    })

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.map)),
    })

    useEffect(() => {
        passosInterno.current.set("Devoluções", () => { })
        onObterDadosDevolucoes();
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="DevolucoesOrcamentoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <DevolucoesOrcamento
                orcamentoSelecionado={props.orcamentoSelecionado}
                devolucoes={dados}
                mostrarDetalhesDevolucoes={mostrarDetalhesDevolucoes}
                devolucoesSelecionada={devolucaoSelecionada}
                onSelecionarMostrarDevolucoes={onSelecionarMostrarDevolucao}
            />
        </>
    );
}
